/* ===================== S3 UPLOAD ===================== */
import api from "./axios";
import { uploadToS3 } from "../utils/uploadToS3";

export const profileApi = {
  /* ===================== PROFILE LOCK / UNLOCK ===================== */
  toggProfileLock: async (newLockState) => {
    const res = await api.put("/user/update-profile", {
      isProfileLocked: newLockState,
    });
    return res.data;
  },

  /* ===================== FETCH USER POSTS ===================== */
  getUserPosts: async ({ userId, cursor = null, limit = 10 }) => {
    const params = { limit };
    if (cursor) params.cursor = cursor;

    const res = await api.get(`/feeds/user/${userId}`, { params });
    return res.data;
  },

  getMyPosts: async ({ cursor = null, limit = 10 }) => {
    const params = { limit };
    if (cursor) params.cursor = cursor;

    const res = await api.get("/feeds/me", { params });
    return res.data;
  },

  getSavedPosts: async ({ cursor = null, limit = 10 }) => {
    const params = { limit };
    if (cursor) params.cursor = cursor;

    const res = await api.get("/saves/me", { params });
    return res.data;
  },

  /* ===================== BLOCK / UNBLOCK USER ===================== */
  blockUser: async (userId) => {
    const res = await api.post(`/user/${userId}/block`);
    return res.data;
  },

  unblockUser: async (userId) => {
    const res = await api.post(`/user/${userId}/unblock`);
    return res.data;
  },

  getBlockedUsers: async () => {
    const res = await api.get("/user/blocked");
    return res.data;
  },

  /* ===================== FOLLOW LIST ===================== */
  getFollowFollowingList: async ({ userId, type, signal }) => {
    if (!userId || !type) {
      throw new Error("userId and type are required");
    }

    const res = await api.get(`/follows/${userId}/${type}`, { signal });
    return res.data;
  },

  /* ===================== UPLOAD PROFILE IMAGE ===================== */
  updateProfileImage: async ({ file, onUploadProgress, signal }) => {
    if (!file) throw new Error("File is required");

    if (!file.type?.startsWith("image/")) {
      throw new Error("Profile image must be an image file");
    }

    // 1️⃣ Upload to S3
    let key;
    try {
      key = await uploadToS3({
        file,
        mediaType: "image",
        signal,
        onProgress: (percent) => {
          onUploadProgress?.({
            loaded: percent,
            total: 100,
          });
        },
      });
    } catch (error) {
      throw new Error(`Failed to upload profile image: ${error.message}`);
    }

    // 2️⃣ Send key to backend
    try {
      const res = await api.put("/user/update-profile", {
        profilePic: key,
      });
      return res.data;
    } catch (error) {
      throw new Error(
        `Image uploaded but failed to save profile: ${
          error.response?.data?.message || error.message
        }`,
      );
    }
  },

  /* ===================== UPLOAD COVER IMAGE ===================== */
  updateCoverImage: async ({ file, onUploadProgress, signal }) => {
    if (!file) throw new Error("File is required");

    if (!file.type?.startsWith("image/")) {
      throw new Error("Cover image must be an image file");
    }

    let key;
    try {
      key = await uploadToS3({
        file,
        mediaType: "image",
        signal,
        onProgress: (percent) => {
          onUploadProgress?.({
            loaded: percent,
            total: 100,
          });
        },
      });
    } catch (error) {
      throw new Error(`Failed to upload cover image: ${error.message}`);
    }

    try {
      const res = await api.put("/user/update-profile", {
        coverPic: key,
      });
      return res.data;
    } catch (error) {
      throw new Error(
        `Image uploaded but failed to save profile: ${
          error.response?.data?.message || error.message
        }`,
      );
    }
  },

  /* ===================== UPLOAD SIGNATURE ===================== */
  saveSignature: async ({ file, onUploadProgress, signal }) => {
    if (!file) throw new Error("Signature file is required");

    if (!file.type?.startsWith("image/")) {
      throw new Error("Signature must be an image file");
    }

    // 1️⃣ Upload to S3
    let key;
    try {
      key = await uploadToS3({
        file,
        mediaType: "image", // NOTE: confirm with backend whether /media/presign
        // expects "image" or a dedicated "signature" mediaType — if the presign
        // route validates mediaType against an enum, sending the wrong value
        // here will cause a silent rejection or wrong S3 key prefix.
        signal,
        onProgress: (percent) => {
          onUploadProgress?.({
            loaded: percent,
            total: 100,
          });
        },
      });
    } catch (error) {
      throw new Error(`Failed to upload signature: ${error.message}`);
    }

    // 2️⃣ Send key to backend
    try {
      const res = await api.post("/revolution/signature", {
        signature: key,
      });
      return res.data;
    } catch (error) {
      throw new Error(
        `Signature uploaded but failed to save: ${
          error.response?.data?.message || error.message
        }`,
      );
    }
  },

  /* ===================== GET SIGNATURE ===================== */
  getSignature: async () => {
    const res = await api.get("/revolution/signature");
    return res.data;
  },

  /* ===================== MONETIZATION ===================== */
  getMonetizePostLimit: async () => {
    const res = await api.get("/user/monetized-post-limits");
    return res.data;
  },

  /* ===================== REPORT USER ===================== */
  reportProfile: async (userId, reason = "something else") => {
    const res = await api.post(`/user/report/${userId}`, { reason });
    return res.data;
  },
};

// ===============================================================================================

// import api from "./axios";

// export const profileApi = {
//  /* ===================== PROFILE LOCK / UNLOCK ===================== */
//  toggProfileLock: async (newLockState) => {
//    const res = await api.put("/user/update-profile", {
//      isProfileLocked: newLockState,
//    });
//    return res.data;
//  },

//  /* ===================== FETCH USER POSTS ===================== */

//  // Current getUserPosts (replace with cursor-based version)
//  getUserPosts: async ({ userId, cursor = null, limit = 10 }) => {
//    const params = { limit };
//    if (cursor) params.cursor = cursor;
//    const res = await api.get(`/feeds/user/${userId}`, { params });
//    return res.data;
//  },

//  // Current getMyPosts (replace with cursor-based version)
//  getMyPosts: async ({ cursor = null, limit = 10 }) => {
//    const params = { limit };
//    if (cursor) params.cursor = cursor;
//    const res = await api.get("/feeds/me", { params });
//    return res.data;
//  },

//  // Current getSavedPosts (replace with cursor-based version)
//  getSavedPosts: async ({ cursor = null, limit = 10 }) => {
//    const params = { limit };
//    if (cursor) params.cursor = cursor;
//    const res = await api.get("/saves/me", { params });
//    return res.data;
//  },

//  /* ===================== BLOCK / UNBLOCK USER ===================== */
//  blockUser: async (userId) => {
//    const res = await api.post(`/user/${userId}/block`);
//    return res.data;
//  },

//  unblockUser: async (userId) => {
//    const res = await api.post(`/user/${userId}/unblock`);
//    return res.data;
//  },

//  /* ===================== GET BLOCKED USER ===================== */
//  getBlockedUsers: async () => {
//    const res = await api.get("/user/blocked");
//    return res.data;
//  },

//  /* ===================== FETCH FOLLOW LIST ===================== */
//  getFollowFollowingList: async ({ userId, type, signal }) => {
//    if (!userId || !type) {
//      throw new Error("userId and type are required");
//    }
//    const res = await api.get(`/follows/${userId}/${type}`, { signal });
//    return res.data;
//  },

//  /* ===================== GET LOGGED IN USER SIGNATURE ===================== */
//  getSignature: async () => {
//    const res = await api.get("revolution/signature");
//    return res.data;
//  },

//  /* ===================== GET LOGGED IN USER SIGNATURE ===================== */
//  getMonetizePostLimit: async () => {
//    const res = await api.get("/user/monetized-post-limits");
//    return res.data;
//  },

//  /* ===================== REPORT USER ===================== */
//  reportProfile: async (userId, reason = "something else") => {
//    const res = await api.post(`/user/report/${userId}`, { reason });
//    return res.data;
//  },

//  saveSignature: (formData) =>
//    api.get("/revolution/signature", formData, {
//      headers: { "Content-Type": "multipart/form-data" },
//    }),
// };

// /* ===================== S3 UPLOAD ===================== */
// import api from "./axios";
// import { uploadToS3 } from "../utils/uploadToS3";

// export const profileApi = {
//   /* ===================== PROFILE LOCK / UNLOCK ===================== */
//   toggProfileLock: async (newLockState) => {
//     const res = await api.put("/user/update-profile", {
//       isProfileLocked: newLockState,
//     });
//     return res.data;
//   },

//   /* ===================== FETCH USER POSTS ===================== */
//   getUserPosts: async ({ userId, cursor = null, limit = 10 }) => {
//     const params = { limit };
//     if (cursor) params.cursor = cursor;

//     const res = await api.get(`/feeds/user/${userId}`, { params });
//     return res.data;
//   },

//   getMyPosts: async ({ cursor = null, limit = 10 }) => {
//     const params = { limit };
//     if (cursor) params.cursor = cursor;

//     const res = await api.get("/feeds/me", { params });
//     return res.data;
//   },

//   getSavedPosts: async ({ cursor = null, limit = 10 }) => {
//     const params = { limit };
//     if (cursor) params.cursor = cursor;

//     const res = await api.get("/saves/me", { params });
//     return res.data;
//   },

//   /* ===================== BLOCK / UNBLOCK USER ===================== */
//   blockUser: async (userId) => {
//     const res = await api.post(`/user/${userId}/block`);
//     return res.data;
//   },

//   unblockUser: async (userId) => {
//     const res = await api.post(`/user/${userId}/unblock`);
//     return res.data;
//   },

//   getBlockedUsers: async () => {
//     const res = await api.get("/user/blocked");
//     return res.data;
//   },

//   /* ===================== FOLLOW LIST ===================== */
//   getFollowFollowingList: async ({ userId, type, signal }) => {
//     if (!userId || !type) {
//       throw new Error("userId and type are required");
//     }

//     const res = await api.get(`/follows/${userId}/${type}`, { signal });
//     return res.data;
//   },

//   /* ===================== UPLOAD PROFILE IMAGE ===================== */
//   updateProfileImage: async ({ file, onUploadProgress }) => {
//     if (!file) throw new Error("File is required");

//     // 1️⃣ Upload to S3
//     const key = await uploadToS3({
//       file,
//       mediaType: "image",
//       onProgress: (percent) => {
//         onUploadProgress?.({
//           loaded: percent,
//           total: 100,
//         });
//       },
//     });

//     // 2️⃣ Send key to backend
//     const res = await api.put("/user/update-profile", {
//       profileImage: key,
//     });

//     return res.data;
//   },

//   /* ===================== UPLOAD COVER IMAGE ===================== */
//   updateCoverImage: async ({ file, onUploadProgress }) => {
//     if (!file) throw new Error("File is required");

//     const key = await uploadToS3({
//       file,
//       mediaType: "image",
//       onProgress: (percent) => {
//         onUploadProgress?.({
//           loaded: percent,
//           total: 100,
//         });
//       },
//     });

//     const res = await api.put("/user/update-profile", {
//       coverImage: key,
//     });

//     return res.data;
//   },

//   /* ===================== UPLOAD SIGNATURE ===================== */
//   saveSignature: async ({ file, onUploadProgress }) => {
//     if (!file) throw new Error("Signature file is required");

//     // 1️⃣ Upload to S3
//     const key = await uploadToS3({
//       file,
//       mediaType: "image", // or "signature" if backend supports
//       onProgress: (percent) => {
//         onUploadProgress?.({
//           loaded: percent,
//           total: 100,
//         });
//       },
//     });

//     // 2️⃣ Send key to backend
//     const res = await api.post("/revolution/signature", {
//       signature: key,
//     });

//     return res.data;
//   },

//   /* ===================== GET SIGNATURE ===================== */
//   getSignature: async () => {
//     const res = await api.get("/revolution/signature");
//     return res.data;
//   },

//   /* ===================== MONETIZATION ===================== */
//   getMonetizePostLimit: async () => {
//     const res = await api.get("/user/monetized-post-limits");
//     return res.data;
//   },

//   /* ===================== REPORT USER ===================== */
//   reportProfile: async (userId, reason = "something else") => {
//     const res = await api.post(`/user/report/${userId}`, { reason });
//     return res.data;
//   },
// };
